// @ts-nocheck
import { get } from "@insite/client-framework/Services/ApiService";
import { PersonasListModel } from "@store/Framework/Types/ApiModels";

export async function getPersonas() {
    const personaData = await get<PersonasListModel[]>("api/v1/custom/personas", {});

    return personaData;
}
